import 'swiper/scss';
import { FreeMode } from 'swiper';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Entry } from 'contentful';

import { client } from '../../helpers/contentful';
import { Spinner, ToolCard, SkeletonPage } from '../../components';
import { IBrushFields } from '../../@types/generated/contentful';

const InteriorDesign = () => {
  const [brushes, setBrushes] = useState<Entry<IBrushFields>[]>([]);
  const [newBrushes, setNewBrushes] = useState<Entry<IBrushFields>[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const getNewBrushes = async () => {
      const response = await client
        .getEntries<IBrushFields>({
          'fields.categoryName': 'Interior Design',
          content_type: 'brush',
          'fields.featuredText[exists]': true,
        })
        .then((r) => r.items);

      return response;
    };

    getNewBrushes().then((r) => setNewBrushes(r));
  }, []);

  const getBrushes = async () => {
    const response = await client
      .getEntries<IBrushFields>({
        skip: brushes.length,
        limit: 12,
        'fields.categoryName': 'Interior Design',
        content_type: 'brush',
      })
      .then((r) => r);

    if (total === 0) {
      setTotal(response.total);
    }

    setBrushes((state) => [...state, ...response.items]);
    return response.items;
  };

  useEffect(() => {
    getBrushes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='home'>
      {brushes.length > 0 && newBrushes ? (
        <>
          {newBrushes.length > 0 && (
            <div className='pb-5 border-t-2 px-6 xs:px-4'>
              <div className='max-w-[770px] mx-auto pt-6 pb-4 '>
                <h2 className='text-lg leading-xl font-bold'>This week update</h2>
              </div>
              <Swiper
                modules={[FreeMode]}
                slidesPerView='auto'
                spaceBetween={12}
                centerInsufficientSlides
                breakpoints={{ 480: { spaceBetween: 20 } }}
              >
                {newBrushes.map(({ fields, sys }) => (
                  <SwiperSlide className='w-[204px] sm:w-[180px] xs:w-[170px]' key={sys.id}>
                    <ToolCard size='small' set={fields} category='Interior Design' isFeatured />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
          <div className='border-t-2 w-full'>
            <div className='mx-auto w-max p-6 xs:p-4 xxs:mx-0 xxs:w-full'>
              <h2 className='text-lg leading-xl font-bold mb-4'>All brushes</h2>
              <InfiniteScroll
                dataLength={brushes.length}
                next={getBrushes}
                // eslint-disable-next-line react/jsx-boolean-value
                hasMore={brushes.length < total}
                scrollableTarget='app'
                style={{ overflow: 'visible' }}
                loader={
                  <div className='mt-4 flex justify-center'>
                    <Spinner theme='light' />
                  </div>
                }
              >
                <ul className='grid xxs:grid-cols-1 gap-5 md:grid-cols-2 grid-cols-3 w-max xs:gap-3 xxs:mx-auto'>
                  {brushes.map(({ fields, sys }) => (
                    <li key={sys.id}>
                      <ToolCard size='large' set={fields} category='Interior Design' />
                    </li>
                  ))}
                </ul>
              </InfiniteScroll>
            </div>
          </div>
        </>
      ) : (
        <SkeletonPage title='brushes' />
      )}
    </div>
  );
};

export { InteriorDesign };
